import { OrderKeys } from '../../../../ts/models/OrderKeys';
import { SortOptions } from '../../../../ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '../../../../ts/models/sort/SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from '../../../../ts/models/sort/SortOptionsHelper';

export const groupSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'domainName': createNonDisplayOptionDefinition('domainName', OrderKeys.domainName),
  'minSiteRole': createNonDisplayOptionDefinition('minSiteRole', OrderKeys.minimumSiteRole),
  'userCount': createNonDisplayOptionDefinition('userCount', OrderKeys.userCount),
  'grantLicenseMode': createNonDisplayOptionDefinition('grantLicenseMode', OrderKeys.grantLicenseMode),
};
